module.exports = __webpack_public_path__ + "img/imgXharra-10.d0954d22.png";